export const COLORS = {
    schoolGold: "#B3A369",
    // darkColor: "#2a2a2a",
    darkColor: "#212B31",
    schoolGreen: "#00703c",
    mainWhite: "#FFF",
    linkGreen: "#5DA355",
}